import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../../styles/index.sty';
import AlertSnack from '../../../components/Alert/AlertSnack'
import { useAuth } from '../../../context/authContext'
import { useLists } from '../../../context/listContext'
import { insertFinishData, updateFinishData } from '../../../api/attributes.api'

export const AddFinish = () => {
  const { config } = useAuth();
  const { fetchFinishesList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    finish_name: location?.state?.data?.finish_name,
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateFinishData({...values, product_finish_id: location?.state?.data?.product_finish_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchFinishesList();
        if(submit.status === "success") {
          navigate("/finishes");
        }
      } else {
        const submit = await insertFinishData(values, config);
        setResponse(submit);
        fetchFinishesList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/finishes");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Finish Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="finish_name">Finish Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="finish_name"
            placeholder="Enter Finish Name"
            id="finish_name"
            type="text"
            value={formik.values.finish_name}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/finishes")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};
